// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__39wQc","enable":"Auth_enable__2o_Tm"};